export default [
  '#06b500', '#7cd98e', '#48bdb5', '#4cd128', '#1cb87e', '#00c9bf', '#089c92', '#7acf7b', '#32bf89', '#a0ebca',
  '#47b8c4', '#032096', '#353547', '#58a5e0', '#689ff7', '#376894', '#325757', '#8690c2', '#476a91', '#2b3087',
  '#031f01', '#194f08', '#b0c24a', '#69620e', '#a4c240', '#838f15', '#2b2b05', '#4d6112', '#0a240b', '#3d2d05',
  '#d819fa', '#332028', '#250738', '#7d3371', '#d19dfc', '#8a0849', '#8a436b', '#7118f5', '#b87cd9', '#875079'
];

export const DARK_GREEN = '#2E7D32';
export const GREEN = '#4CAF50';
export const ORANGE = '#ff9600';
export const YELLOW = '#FFEE58';
export const RED = '#ff2323';
export const DARK_RED = '#941b1e';
export const KPI_RED = '#F4664A';
export const KPI_YELLOW = '#FAAD14';
export const KPI_GREEN = '#30BF78';